import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Table from "./../../operations/Orders/Table";
import Details from "../../operations/Orders/Details";

class OrdersRouter extends Component {
  render() {
    let { router, ...props } = this.props;
    let details = { ...props };
    details.url = "/customer-support";
    details.className = "cx-listing";
    if (router.match.params.id) {
      let details = { ...this.props };
      details.url = "/customer-support";
      return <Details {...details} />;
    }
    return <Table {...details} />;
  }
}

export default withRouter(({ match, ...props }) => (
  <OrdersRouter router={{ match }} {...props} />
));
